import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "vab-icon-vuejs-fill",
  "use": "vab-icon-vuejs-fill-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"vab-icon-vuejs-fill\">\r\n  <path fill=\"none\" d=\"M0 0h24v24H0z\" />\r\n  <path d=\"M1 3h4l7 12 7-12h4L12 22 1 3zm8.667 0L12 7l2.333-4h4.035L12 14 5.632 3h4.035z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol